import Swiper, { Navigation, Pagination } from "swiper";

export default class PhotoSlider {
  constructor(selector = ".c-photo-slider__slider") {
    document.querySelectorAll(selector).forEach((el) => this.init(el));
  }

  init(el) {
    // 画像が1枚だけのときはスライダー化しない（矢印・ページネーションも出力されない）
    if (el.querySelectorAll(".swiper-slide").length <= 1) return;

    const root = el.closest(".c-photo-slider");
    const nextEl = root?.querySelector(".c-photo-slider__btn.-next");
    const prevEl = root?.querySelector(".c-photo-slider__btn.-prev");
    const paginationEl = root?.querySelector(".c-photo-slider__pagination");

    new Swiper(el, {
      modules: [Navigation, Pagination],
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 16,
      centeredSlides: true,
      grabCursor: true,
      navigation: {
        nextEl,
        prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 40,
        },
      },
    });
  }
}
